import { animate, state, style, transition, trigger, } from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { TableauMessages } from '../../../models/component-messages/tableau-messages';
import { TableContent } from './model/table.content';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LogService } from '../../../services/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '../../../modals/information/information.component';
import { CanNavigateInStepperService } from '../../../services/can-navigate-in-stepper.service';
import { Router } from '@angular/router';
import { Constants } from '../../models/constants';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../services/http.service';
import { SessionService } from '../../../../administration/services/session.service';
import { Endpoints } from '../../../../../models/endpoints';
import { Avis } from '../../../../../models/avis';
import { AvisItem } from '../../../../avisDePub/lister-avis-de-pub/model/avis.item';
import { TableActionService } from './services/table.action.service';
import { StatutAvisEnum } from '../../../../../models/enums/statut-avis.enum';
import { AvisDataTransferService } from '../../../services/avis-data-transfer.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { AvisService } from '../../../../avisDePub/services/avis-service';
import { AvisRevision } from '../../../../../models/avisRevision';
import { HistoRefConsultModalComponent } from '../../../modals/histo-ref-consult-modal/histo-ref-consult-modal.component';

@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class TableauComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  @Input() tableContent: TableContent;
  @Output() actionEvent: EventEmitter<any> = new EventEmitter();
  @Input() form: FormGroup;
  @Input() sortingColumn: { name: string, start: 'asc' | 'desc' } = {name: '', start: 'asc'};
  @Input() isChoixFormulaire: boolean;

  @Output() sortColumnChangeEmiter = new EventEmitter<any>();

  public tableauMessage = new TableauMessages();
  public tableDataSrc: MatTableDataSource<any> = new MatTableDataSource();
  public expandedElement: Data[] = [];
  public expandedColumn: string[] = [];
  public usersData: any[] = [];
  public dataRows: FormGroup = new FormGroup({});
  public isForm = false;
  public myjson: any = JSON;
  public firstSort = true;
  public formChecked = '';
  public aviRef: any[] = [];
  public inputValue = null;
  @Input() totalItems;
  pageSize = 5;
  page = 0;
  public avis: any;
  public liables: any = [];
  public reliables: any = [];
  public canBeLier = false;
  public referenceValue = '';
  public dashboardFilter = false;
  public avisNbPerPage = 0;
  @Input()
  public statutCode: string;
  @Input() enableFilter: boolean;
  private LOG: LogService = new LogService(TableauComponent);
  private sortColumn: string;
  private sortOrder: string;
  private avisAnnulationPublie: string[] = [];
  private liablesSubscription: Subscription;
  private reliablesSubscription: Subscription;
  private canBeLierSubscription: Subscription;
  private avisSubscription: Subscription;
  private subscriptions: Subscription[] = [];
  /** Messages de refus déjà récupérés, par référence d'avis : un nouveau clic les affiche sans appel. */
  private statusMessages = new Map<string, string>();

  constructor(public translate: TranslateService,
              private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private canNavigateInStepperService: CanNavigateInStepperService,
              private modalService: NgbModal,
              private canNavigate: CanNavigateInStepperService,
              private router: Router,
              private httpService: HttpService,
              private session: SessionService,
              private translateService: TranslateService,
              public tableActionService: TableActionService, private avisDataTransferService: AvisDataTransferService,
              private spinner: SpinnerVisibilityService, private avisService: AvisService) {
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.avisDataTransferService.page = 0;
    this.avisDataTransferService.pageSize = 5;
  }

  public ngAfterViewInit() {
    if (!this.dashboardFilter) {
      this.sort.sortChange.subscribe((event) => {
        if (event.active != 'supportdediffusion' && event.active != 'avisLie' && event.active != 'typedavis') {
          this.sortColumn = event.active;
          this.sortOrder = event.direction;
          this.retrieveItems(this.translateService, this.page, this.pageSize, this.referenceValue, event.active, event.direction);
          const sortState = {name: event.active, start: event.direction};
          this.sortColumnChangeEmiter.emit(sortState);

        }
      });
    }
  }

  public ngOnInit() {
    this.dashboardFilter = this.canNavigateInStepperService.isChoixFormulaire;
    this.isForm = this.form !== undefined && this.form !== null;
    if (!this.isForm) {
      this.form = new FormGroup({});
    }
    this.getReferentielEformAvisLies();
    this.getAvisLiesAnnulationPublie();
    this.getAllNoticesProcedureId();
    this.form.addControl(Constants.TABLE_DATA_CTRL_NAME, this.dataRows);
    this.getData();

    if (this.router.url.includes('creerAvisPub')) {
      this.canNavigate.currentFormulaire = '';
      this.canNavigate.currentNormeFormulaire = '';
    }
    this.canNavigateInStepperService.mockedEnabledForms(this.enabledForms.bind(this));
    // On s'abonne pour récupérer les valeurs à jour du service et on prépare la liste de souscriptions à détruire
    this.liablesSubscription = this.tableActionService.liables.subscribe(updatedLiables => this.liables = updatedLiables);
    this.subscriptions.push(this.liablesSubscription);
    this.reliablesSubscription = this.tableActionService.reliables.subscribe(updatedReliables => this.reliables = updatedReliables);
    this.subscriptions.push(this.reliablesSubscription);
    this.canBeLierSubscription = this.tableActionService.canBeLier.subscribe(e => this.canBeLier = e);
    this.subscriptions.push(this.canBeLierSubscription);
    this.avisSubscription = this.tableActionService.avis.subscribe(updatedAvis => this.avis = updatedAvis);
    this.subscriptions.push(this.avisSubscription);
  }

  public getData() {
    this.tableContent.tableData.subscribe((data) => {
      if (data) {
        this.usersData = data;
        data?.forEach(item => {
          item.datedecreation = new Date(item?.datedecreation);
        });
        // expandable
        data.forEach((principalRowData) => {

          // dans le cas d'un formulaire
          if (this.isForm) {
            const row = this.fb.group({
              develop: new FormControl(principalRowData.develop),
              checkbox: new FormControl(principalRowData.checkbox),
              zonediffusion: new FormControl(principalRowData.zonediffusion),
              diffuseur: new FormControl(principalRowData.support),
              format: new FormControl(principalRowData.format),
              children: new FormGroup({}),
              // checked du premier niveau
              checked: new FormControl(principalRowData.checked)
            });
            const zonediffusionctrl: any = row.controls.zonediffusion;
            zonediffusionctrl.disable();
            const diffuseurctrl: any = row.controls.diffuseur;
            diffuseurctrl.disable();
            const formatctrl: any = row.controls.format;
            formatctrl.disable();
            // ajout d'une ligne dans le tableau
            this.dataRows.addControl(principalRowData.id, row);
          }

          if (principalRowData && principalRowData.children && Array.isArray(principalRowData.children) && principalRowData.children.length) {
            principalRowData.children.forEach((element) => {
              if (this.tableContent.tableCols.find((value) => 'action' === value.columnDef)) {
                element.actions = [];
                this.tableContent.tableCols.find((value) => 'action' === value.columnDef).actions.forEach((item) => {
                  const action = {
                    description: item.description,
                    icon: item.icon,
                    matTooltip: item.matTooltip,
                    type: item.type,
                  };
                  element.actions.push(action);
                });
              }

              const row = this.fb.group({
                develop: new FormControl(element.develop),
                checkbox: new FormControl(principalRowData.checkbox),
                zonediffusion: new FormControl(element.zonediffusion),
                diffuseur: new FormControl(element.support),
                format: new FormControl(element.format),
                children: new FormGroup({}),
                // deuxième niveau
                checked: new FormControl(element.checked)
              });
              const zonediffusionctrl: any = row.controls.zonediffusion;
              zonediffusionctrl.disable();
              const diffuseurctrl: any = row.controls.diffuseur;
              diffuseurctrl.disable();
              const formatctrl: any = row.controls.format;
              formatctrl.disable();

              ((this.dataRows.controls[principalRowData.id] as FormGroup).controls.children as FormGroup).addControl(element.id, row);
              this.usersData[this.usersData.indexOf(principalRowData)] = {
                ...principalRowData,
                addresses: new MatTableDataSource(principalRowData.children),
              };
            });
          }
        });

        // table princip
        this.tableDataSrc = new MatTableDataSource(this.usersData);
        // column pour l'expend child
        if (this.tableContent.expandedColumn.length > 0) {
          this.expandedColumn = this.tableContent.expandedColumn;
        }

        // Trad auto
        forkJoin({
          itemsPerPageLabel: this.translate.get(
            this.tableauMessage.itemsPerPage
          ),
          nextPageLabel: this.translate.get(this.tableauMessage.nextPage),
          previousPageLabel: this.translate.get(
            this.tableauMessage.previousPage
          ),
          firstPageLabel: this.translate.get(this.tableauMessage.firstPage),
          lastPageLabel: this.translate.get(this.tableauMessage.lastPage),
        }).subscribe((values) => {
          this.paginator._intl.itemsPerPageLabel = values.itemsPerPageLabel;
          this.paginator._intl.nextPageLabel = values.nextPageLabel;
          this.paginator._intl.previousPageLabel = values.previousPageLabel;
          this.paginator._intl.firstPageLabel = values.firstPageLabel;
          this.paginator._intl.lastPageLabel = values.lastPageLabel;
          this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
            const start = page * pageSize + 1;
            let end = length;
            if (this.paginator.pageSize < length && this.paginator.getNumberOfPages() > page + 1) {
              end = (page + 1) * this.paginator.pageSize;
            }
            return (`${start} - ${end} ` + this.translate.instant(this.tableauMessage.of) + ` ${length}`);
          };
          if (this.dashboardFilter) {
            this.tableDataSrc.sort = this.sort;
          }
          if (this.canNavigateInStepperService.reference) {
            sessionStorage.setItem('referenceConsultation', this.canNavigateInStepperService.reference);
            this.tableDataSrc.filter = this.canNavigateInStepperService.reference;
            if (!this.isChoixFormulaire) {
              this.inputValue = this.canNavigateInStepperService.reference;
              this.referenceValue = this.canNavigateInStepperService.reference;
              // Ne pas appeler filter() si les données ont déjà été filtrées côté serveur (décrochage PLACE optimisé)
              // On vérifie si les données actuelles sont déjà filtrées en regardant si elles contiennent la référence
              const alreadyFiltered = this.usersData.length > 0 &&
                this.usersData.every(item =>
                  item.referencedelaconsultation?.includes(this.referenceValue) ||
                  item.numero?.includes(this.referenceValue)
                );

              if (!alreadyFiltered) {
                // Données non filtrées : déclencher le filtrage côté serveur
                this.filter(this.referenceValue);
              }
            }
            this.canNavigateInStepperService.reference = null;
          }
          this.tableDataSrc.filterPredicate = (data: any, filter: string) => {
            filter = filter.toLowerCase();
            const fieldsToSearch = ['numero', 'referencedelaconsultation', 'typedemarche', 'intituledeformulaire', 'intitule'];
            for (const field of fieldsToSearch) {
              if (data[field] && data[field].toLowerCase().includes(filter)) {
                return true;
              }
            }
            return false;
          };
          if (this.isChoixFormulaire) {
            this.tableDataSrc.paginator = this.paginator;
            if (this.sortingColumn && this.sortingColumn.name) {
              this.sort.sort({id: this.sortingColumn.name, start: this.sortingColumn.start, disableClear: false});
            }
          }
        });
      }
    });
    this.cd.detectChanges();
  }

  public handlePage(e: any) {
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
      const start = page * pageSize + 1;
      let end = length;
      if (this.paginator.pageSize < length && this.paginator.getNumberOfPages() > page + 1) {
        end = (page + 1) * this.paginator.pageSize;
      }
      return (`${start} - ${end} ` + this.translate.instant(this.tableauMessage.of) + ` ${length}`);
    };
    if (!this.isChoixFormulaire) {
      this.page = e.pageIndex;
      this.avisDataTransferService.page = this.page;
      this.pageSize = e.pageSize;
      this.avisDataTransferService.pageSize = this.pageSize;
      const page = e.pageIndex;
      const pageSize = e.pageSize;
      this.retrieveItems(
        this.translateService,
        page,
        pageSize,
        this.referenceValue,
        this.sortColumn && this.sortOrder ? this.sortColumn : undefined,
        this.sortColumn && this.sortOrder ? this.sortOrder : undefined,
        this.statutCode,
        this.enableFilter
      );
    }
    this.avisNbPerPage = 0;
    if ((((this.paginator.pageIndex + 1) * this.paginator.pageSize) - (this.paginator.length)) > 0) {
      this.avisNbPerPage = (((this.paginator.pageIndex + 1) * this.paginator.pageSize) - (this.paginator.length));
    }
  }

  filter(filter?: any) {
    this.page = 0;
    this.retrieveItems(this.translateService, this.page, this.pageSize, filter, null, null, this.statutCode, this.enableFilter);
    this.paginator.firstPage();
  }

  retrieveItems(translateService: any, page: number, pageSize: number, filter?: any, sortColumn?: any, sortOrder?: any, statut?: string, enableFilter?: boolean) {
    let url;
    url = Endpoints.AVIS_FIND_ALL + Endpoints.ADMIN_SIRET
      + this.session.getUser()?.siret + Endpoints.ADMIN_SERVICE
      + this.session.getUser()?.service + Endpoints.AVIS_LIES
      + Endpoints.AVIS_LIES + true
      + '&page=' + page + '&pageSize=' + pageSize;

    if (filter) {
      url += '&filter=' + filter;
    }
    if (enableFilter) {
      url += '&status=' + statut;
    }
    if (sortColumn) {
      url += '&sortColumn=' + sortColumn;
    }
    if (sortOrder) {
      url += '&sortOrder=' + sortOrder;
    }
    this.httpService.get(url).subscribe((data: any) => {
        const self = this;
        const resultArray = data.avis.map(function(item) {
          const avis: Avis = item;
          const avisItem: AvisItem = new AvisItem();
          avisItem.datedecreation = avis.dateCreation;
          avisItem.datedemodification = avis.dateModification;
          avisItem.avisId = avis.avisId;
          avisItem.numero = avis.reference;
          avisItem.referencedelaconsultation = avis.refConsultation;
          avisItem.statut = StatutAvisEnum[avis.statut];
          avisItem.typeAvis = avis.critere?.typeAvis.libelle;
          avisItem.typedemarche = avis.intituleDuMarche ?? avis.critere?.typeMarche.libelle;
          avisItem.formulairecode = avis.formulaire.code;
          avisItem.norme = avis.formulaire.typeNorme;
          avisItem.intituledeformulaire = avis.formulaire.intitule;
          avisItem.raisonSociale = avis.user?.raisonSociale;
          avisItem.service = avis.user?.service;
          avisItem.motif = avis.motifModification ? 'eform-not-editable.code|name|change-corrig-justification.' + avis.motifModification : null;
          if (avisItem.motif) {
            avisItem.intituledeformulaire = avisItem.intituledeformulaire + ' | ' + translateService.instant(avisItem.motif);
          }
          avisItem.isLie = avis.refAvisLie !== undefined && avis.refAvisLie !== null && avis.refAvisLie !== '';
          avisItem.hasAvisLies = avis.hasAvisLies ?? false;
          if (avis.flux != null) {
            avisItem.urlBoamp = avis.flux[0]?.fluxBoamp?.urlBoamp;
            avisItem.datedepublication = avis.flux[0]?.fluxBoamp?.datePublicationBoamp ?? avis.flux[0]?.fluxBoamp?.datePublicationJoue ?? null;
            avisItem.datedenvoi = avis.flux[0]?.dateEmission;
            avisItem.formulairevalues = {
              'idweb': avis.flux[0]?.fluxBoamp?.idJoue,
              'datePublication': avis.flux[0]?.fluxBoamp?.datePublicationBoamp ?? avis.flux[0]?.fluxBoamp?.datePublicationJoue ?? null
            };
            avisItem.diffuseurs = avis.flux.map(flux => flux.id?.diffuseurId).filter((el, i, a) => i === a.indexOf(el));
            avisItem.supportdediffusion = avis.flux.map(flux => flux.id?.supportDiffusion).filter((el, i, a) => i === a.indexOf(el));
          }
          if (!self.avisDataTransferService.reference.includes(avis.reference)) {
            self.avisDataTransferService.reference.push(avis.reference);
            self.avisDataTransferService.refAvisLie.push(avis.refAvisLie);
          }
          avisItem.eformIdParentNotice = avis.eformIdParentNotice;
          return avisItem;
        });
        this.tableContent.tableData.next(resultArray);
        this.totalItems = data.totalItems;
      },
      error => {
        this.LOG.error(error);
      });

  }

  public onSearchInput(ev) {
    const searchTarget = ev.target.value;
    this.tableDataSrc.filter = searchTarget.trim().toLowerCase();
  }

  public getEvent(event, element, id) {
    this.formChecked = element.enum;
    if ((id === 'INPUT_1' || id === 'INPUT_7') && !element.formulairecode) {
      const value = ((this.dataRows.controls[element.id] as FormGroup).controls.checked as FormGroup).value;
      const keys = Object.keys(((this.dataRows.controls[element.id] as FormGroup).controls.children as FormGroup).controls);
      for (const key of keys) {
        (((this.dataRows.controls[element.id] as FormGroup).controls.children as FormGroup).controls[key] as FormGroup).controls.checked.setValue(value);
      }
    }

    if (event.type === 'Information') {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = element.intitule;
      modalRef.componentInstance.contentTitle = this.tableauMessage.contentTitle;
      modalRef.componentInstance.content = element.description;
      modalRef.componentInstance.footerTitle = this.tableauMessage.footerTitle;
      modalRef.componentInstance.url = element.url;
      modalRef.componentInstance.link = 'Description de l\'' + element.intitule + ' sur le site du BOAMP';
    }
    this.canNavigateInStepperService.sendElement(element.enum);
    this.actionEvent.emit({action: event, data: element});
  }

  public applyFilter(filterValue: string) {
    this.tableDataSrc.filter = filterValue.toLowerCase();
  }

  isReliable() {
    return this.canNavigateInStepperService.linkableNotices?.length > 0;
  }

  public checkExpanded(element): boolean {
    let flag = false;
    this.expandedElement.forEach((e) => {
      if (e === element) {
        flag = true;
      }
    });
    return flag;
  }

  public toggleRow(element, info) {
    if (element != null && element != undefined) {
      const index = this.expandedElement.indexOf(element);
      if (index === -1) {
        this.expandedElement.push(element);
      } else {
        this.expandedElement.splice(index, 1);
      }
    }
  }

  /**
   * Affiche le message de refus d'un avis.
   *
   * La modale s'ouvre dès le clic, avec un indicateur de chargement : la récupération du
   * message peut interroger PIAMP et prendre plusieurs secondes. Un message vide ou en
   * erreur n'est pas conservé, pour qu'un nouveau clic retente la récupération.
   */
  getStatusInfo(avis) {
    const information: InformationComponent = this.modalService.open(InformationComponent).componentInstance;
    const cachedMessage = this.statusMessages.get(avis.numero);
    if (cachedMessage) {
      information.content = cachedMessage;
      return;
    }

    information.loading = true;
    this.httpService.get(
      Endpoints.AVIS_STATUT_MSG +
      Endpoints.GET_ONE_PARAM1 +
      avis.numero
    ).subscribe({
      next: (data: any) => {
        if (data?.message) {
          this.statusMessages.set(avis.numero, data.message);
          information.content = data.message;
        } else {
          information.content = 'error.message_refus_indisponible';
        }
        information.loading = false;
      },
      error: () => this.showStatusMessageUnavailable(information),
      // En cas d'erreur HTTP, HttpService affiche un toast puis termine sans valeur ni erreur
      complete: () => this.showStatusMessageUnavailable(information)
    });
  }

  private showStatusMessageUnavailable(information: InformationComponent) {
    if (information.loading) {
      information.content = 'error.message_refus_indisponible';
      information.loading = false;
    }
  }

  public enabledForms() {
    if (this.formChecked != '') {
      if (environment.formsEnabled === 'noProd') {
        return JSON.parse(this.canNavigateInStepperService.formsEnabledNoProd).default[this.formChecked];
      } else {
        return JSON.parse(this.canNavigateInStepperService.formsEnabledProd).default[this.formChecked];
      }
    }
  }

  getAvisLies(element: any): void {
    this.tableActionService.liables.next([]);
    this.tableActionService.reliables.next([]);
    this.tableActionService.canBeLier.next(false);
    if (this.tableActionService.obsAvisLies) {
      this.tableActionService.obsAvisLies.unsubscribe();
    }
    return this.tableActionService.getAvisLies(element.numero, element.formulairecode);
  }

  isInitial(type) {
    return type?.formulairecode?.includes('IN') && !this.avisAnnulationPublie.some(element => element.includes(type?.numero));
  }

  public getTabActionEvent(event) {
    this.actionEvent.emit(event);
  }

  isAttribution(type) {
    return type?.formulairecode?.includes('AT');
  }

  isAnnulationPublie(type) {
    const inputString = type?.numero || '';
    const secondHyphenIndex = inputString.indexOf('-', inputString.indexOf('-') + 1);
    const result = secondHyphenIndex !== -1 ? inputString.substring(0, secondHyphenIndex) : inputString;
    return this.avisAnnulationPublie.some(element => element.includes(result));
  }

  isEformOrAnnulation(type, action) {
    if (action === 'Annuler') {
      return (type['formulairecode'].startsWith('E_')) || ((type?.formulairecode?.includes('AT') || type?.formulairecode?.includes('AN') || type?.formulairecode?.includes('RE'))
        && this.isAnnulationPublie(type));
    } else {
      return (type['formulairecode'].startsWith('E_')) || type?.formulairecode?.includes('RE') || type?.formulairecode?.includes('AN') || type?.formulairecode?.includes('AT') && this.isAnnulationPublie(type);
    }
  }

  getAvisLiesByReference(referenceAvis: string) {
    let referenceInitial: string;
    if (referenceAvis != null && referenceAvis != undefined && referenceAvis != '') {
      referenceInitial = referenceAvis.substring(0, 13);
      this.referenceValue = referenceInitial;
      this.tableDataSrc.filter = referenceInitial.toLowerCase();
      this.filter(referenceInitial);
    }

    return false;
  }

  isConsultAvislie(avis: any): boolean {
    return avis.isLie || avis.hasAvisLies;
  }

  getModal(reference: string) {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.content = '';
    modalRef.componentInstance.valider = false;
    this.getErreursParseur(reference).subscribe({
      next: ((data) => {
        if (data.length === 0) {
          modalRef.componentInstance.content = this.tableauMessage.nonCorformeMessage;
        } else {
          const formattedData = data.map((item, index) => `${index + 1}. ${item}`).join('\n');
          modalRef.componentInstance.content = formattedData;
        }
      })
    });
  }

  getIntituleMarche(intitule) {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.content = intitule;
    modalRef.componentInstance.valider = false;
  }

  getHistoRefConsultAvisModal(avisId: number): void {
    this.avisService.getHistoRefConsultAvis(String(avisId)).subscribe({
      next: (revisions: AvisRevision[]) => {
        const modalRef = this.modalService.open(HistoRefConsultModalComponent, { size: 'lg' });
        modalRef.componentInstance.revisions = revisions ?? [];
      },
      error: (error) => {
        this.LOG.error(error);
      }
    });
  }

  private getReferentielEformAvisLies() {
    this.httpService.get(
      Endpoints.REFERENTIEL_EFORM_AVIS_LIES
    ).subscribe((data: any) => {
        this.canNavigateInStepperService.referentielEformAvisLies = data;
      },
      error => {
        this.LOG.error(error);
      });
  }

  private getAvisLiesAnnulationPublie() {
    this.httpService.get(
      Endpoints.AVIS_ANNULATION_PUBLIES
    ).subscribe((data: any) => {
        this.avisAnnulationPublie = data;
      },
      error => {
        this.LOG.error(error);
      });
  }

  private getAllNoticesProcedureId() {
    this.httpService.get(
      Endpoints.NOTICE_PROCEDURE_ID
      + Endpoints.ADMIN_SIRET +
      this.session.getUser()?.siret
    ).subscribe((data: any) => {
        this.avisDataTransferService.noticeProcedureID = data;
      },
      error => {
        this.LOG.error(error);
      });
  }

  private getErreursParseur(reference): Observable<string[]> {
    return this.httpService.get(
      Endpoints.AVIS_ERREUR_PARSEUR_BY_REFERENCE + reference
    );
  }
}

export interface Data {
  children?: any[] | MatTableDataSource<any>;
}
